import { cn } from "../lib/cn";

export interface NotificationDotProps {
	/** Пусто — точка 8px; число или строка — пилюля-счётчик 14px. */
	value?: number | string;
	/** Цвет поверхности, из которой «вырезано» кольцо вокруг бейджа. */
	ringClassName?: string;
	className?: string;
}

/**
 * Красный счётчик из DS: минимум 14px, подпись 8px/500 Geist — единственное
 * место в системе, где вообще есть медиум-начертание. Кольцо в цвет подложки
 * отделяет бейдж от иконки под ним (в DS это inset+outer 0.75px).
 */
export function NotificationDot({ value, ringClassName, className }: NotificationDotProps) {
	if (value == null) {
		return (
			<span
				aria-hidden="true"
				className={cn(
					"block size-2 rounded-full bg-notify ring-[1.5px] ring-card",
					ringClassName,
					className,
				)}
			/>
		);
	}
	return (
		<span
			className={cn(
				"inline-flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-[3px]",
				"bg-notify text-fg-inverse ring-[0.75px] ring-card",
				"font-[500] font-sans text-[8px] leading-[1.4]",
				ringClassName,
				className,
			)}
			style={{ animation: "iec-badge-in var(--dur-react) var(--ease-spring)" }}
		>
			{value}
		</span>
	);
}
